<template>
    <div class="setUserReward">
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table :data="dataList" size="mini" border style="width: 100%">
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="channel_from_text"
                    label="渠道"
                    min-width="90"
                >
                <template slot-scope="scope">
                    {{scope.row.channel_from_text}}
                </template>
                </el-table-column>
                
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="max_rate"
                    label="费率阈值"
                    min-width="150"
                >
                <template slot-scope="scope">
                    <el-input
                        v-model="scope.row.max_rate"
                        size="medium"
                        placeholder="请输入"
                    >
                    <template slot="suffix">
                        <span style = "line-height: 40px;width: 40px;align-items: c;">%</span>
                    </template>
                    </el-input>
                  
                </template>
                
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="max_fee"
                    label="秒到费阈值"
                    min-width="150"
                >
                <template slot-scope="scope">
                   <!-- <el-input
                        v-model="scope.row.max_fee"
                        size="medium"
                        placeholder="请输入"
                    > -->
                    <el-select v-model="scope.row.max_fee"  placeholder="请选择">
                        <el-option label="1" :value="1"></el-option>
                        <el-option label="2" :value="2"></el-option>
                        <el-option label="3" :value="3"></el-option>
                        <el-option label="4" :value="4"></el-option>
                        <el-option label="5" :value="5"></el-option>
                    </el-select>
                    <template slot="suffix">
                        <span style = "line-height: 40px;width: 40px;align-items: c;">元</span>
                    </template>
                    </el-input>
                  
                </template>
                
                </el-table-column>
                
                    
            </el-table>
            <el-button
                @click="handleSubmit()"
                type="primary"
                style="font-size:12px; margin-top:20px"
            >提 交</el-button>
        
        </el-card>
        
    </div>
</template>

<script>
export default {
    name: "UM_setUserReward",
    data() {
        return {
            dataList: [],
            cloneData: [],
            isEdit: null,
            level: sessionStorage.getItem('level'),
            isAdd:null,  //0 未提交数据 1首次提交数据 
        }
    },
    created() {
        this.getChannel()
    },
    mounted() {
    },
    methods: {
        handleSubmit() {
            
            this.$api.post('platform_rate_up/channelRateSettingUpdate', {data:this.dataList}, res => {
                if (res.code == 0) {
                    this.$message.success(res.msg);
                } else {
                    this.$message({
                        type: 'error',
                        message: res.msg,
                        duration: 5000
                    })
                }
            })
        },
        // 获取渠道阈值
        getChannel() { 
            this.$api.post('platform_rate_up/channelRateSettingDetail', {}, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.dataList = data;
                    this.cloneData = JSON.parse(JSON.stringify(data))
                } else {
                    this.$message.error(res.msg);
                }
            });
        }
    }
}
</script>

<style scoped lang="scss">
.setUserReward {
    ::v-deep .el-form-item__label {
        font-size: 12px;
        font-weight: 700;
    }
    ::v-deep .el-dialog {
        height: 80%;
        .el-dialog__body {
            height: 82%;
            overflow: auto;
        }
    }
    .endTime {
        font-size: 12px;
        color: #aaaaaa;
    }
    .el-input {
        width: auto;
    }
    ::v-deep .el-input__inner {
        width: 200px;
    }

    .type_title {
        margin: 10px 0;
        font-size: 13px;
        font-weight: 700;
        border-left: 5px solid #40b8ff;
        padding: 0 0 0 10px;
    }
}
</style>
